<template>
  <div class="modal_edit_profile">
    <div class="">
      <label> {{ translate("simcard_devices.group") }} </label>
      <tree-select
        v-model="profile.group_id"
        :options="opt_groups"
        :placeholder="translate('simcard_devices.group')"
        :clearable="false"
      />
    </div>
    <div class="">
      <fg-input
        v-model="profile.msissdn"
        type="tel"
        :label="translate('simcard_devices.number')"
        :placeholder="translate('simcard_devices.number')"
        :disabled="true"
      />
    </div>
    <div class="">
      <fg-input
        v-model="profile.imsi"
        type="text"
        :label="translate('simcard_devices.imsi')"
        :placeholder="translate('simcard_devices.imsi')"
        :disabled="true"
      />

      <fg-input
        v-model="profile.iccid"
        type="text"
        :label="translate('simcard_devices.iccid')"
        :placeholder="translate('simcard_devices.iccid')"
        :disabled="true"
      />
    </div>
    <div class="">
      <fg-input
        v-model="profile.apn"
        type="text"
        :label="translate('simcard_devices.apn')"
        :placeholder="translate('simcard_devices.apn')"
        :disabled="true"
      />

      <fg-input
        v-model="profile.operator"
        type="text"
        :label="translate('simcard_devices.operator')"
        :placeholder="translate('simcard_devices.operator')"
        :disabled="true"
      />
    </div>

    <div class="">
      <fg-input
        v-model="profile.tariff"
        type="text"
        :label="translate('simcard_devices.tariff')"
        :placeholder="translate('simcard_devices.tariff')"
        :disabled="true"
      />
    </div>

    <div class="">
      <div class="form-group">
        <label>{{ translate("simcard_devices.description") }}</label>
        <textarea
          v-model="profile.description"
          rows="3"
          class="form-control border-input"
          :placeholder="translate('simcard_devices.description')"
        />
      </div>
    </div>

    <div class="text-center">
      <button
        type="submit"
        class="btn btn-info btn-fill btn-wd marginButton"
        @click.prevent="updateSimcard"
      >
        {{ translate("save") }}
      </button>

      <button
        type="submit"
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate("close_modal") }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "SimcardDevicesEditProfile",
  props: ["simcard"],

  data() {
    return {
      profile: {},
    };
  },
  created() {
    this.profile = { ...this.simcard };
  },
  computed: {
    opt_groups() {
      return this.$store.getters.getSimcardDevicesGroupsTree;
    },
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    updateSimcard() {
      delete this.profile.id;
      this.$http.v1.putSimcardDevices(
        this.profile.imsi,
        { ...this.profile },
        () => {
          this.global_notify("info", this.translate("profile_saved"));
          this.$store.dispatch("deleteLinkSimcardDevices", {
            group: this.simcard.group_id,
            id: this.profile.imsi,
          });
          this.$store.dispatch(
            "updateSimcardDevicesProfile",
            this.profile.imsi
          );
        }
      );
      this.cancel();
    },
  },
};
</script>

<style lang='scss'>
.modal_edit_profile {
  padding: 10px;
}
.marginButton {
  margin: 5px;
}
.v-spinner {
  margin-bottom: 10px;
}
.tdFont {
  font-weight: bold;
}
.block {
  text-align: right;
}
</style>
